import { Box, IconButton, Stack, useTheme } from "@mui/material";
import { Edit3, MessageCircle } from "lucide-react";
import { ChatListRow } from "web_myplann/Chat/Components/ChatListRow";
import { ChatListSearch } from "web_myplann/Chat/Components/ChatListSearch";
import { ChatListSkeleton } from "web_myplann/Chat/Components/ChatListSkeleton";
import { useChatListPage } from "web_myplann/Chat/Hooks/useChatListPage";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { CenteredEmptyState } from "web_myplann/Shared/Components/CenteredEmptyState";
import { MyPlannNavigationHeader } from "web_myplann/Shared/Header/MyPlannNavigationHeader";

export const ChatListPage = () => {
	const theme = useTheme();
	const { t } = useResource();
	const {
		items,
		isLoading,
		query,
		setQuery,
		searchActive,
		clearSearch,
		openConversation,
		openNewMessage,
	} = useChatListPage();

	return (
		<Stack height="100dvh" bgcolor={theme.palette.surface.muted}>
			<MyPlannNavigationHeader
				title={t(Resources.Chat.title)}
				defaultRoute={Routing.Dashboard}
				bgColor={theme.palette.background.paper}
				endComponent={
					<IconButton
						variant="ghost"
						size="large"
						onClick={openNewMessage}
						aria-label={t(Resources.Chat.newMessage)}
					>
						<Edit3 size={theme.iconSize.md} color={theme.palette.grey[600]} />
					</IconButton>
				}
			/>

			<ChatListSearch value={query} onChange={setQuery} />

			<Stack flex={1} minHeight={0} sx={{ overflowY: "auto" }}>
				{isLoading ? (
					<ChatListSkeleton />
				) : items.length === 0 ? (
					<Box px={1.6} pt={3.2}>
						<CenteredEmptyState
							icon={MessageCircle}
							title={
								searchActive
									? t(Resources.Chat.searchEmptyTitle)
									: t(Resources.Chat.listEmptyTitle)
							}
							description={
								searchActive
									? t(Resources.Chat.searchEmptyDescription)
									: t(Resources.Chat.listEmptyDescription)
							}
							actionLabel={
								searchActive
									? t(Resources.Chat.clearSearch)
									: t(Resources.Chat.writeToAdvisor)
							}
							onAction={searchActive ? clearSearch : openNewMessage}
						/>
					</Box>
				) : (
					<>
						<Box bgcolor={theme.palette.background.paper}>
							{items.map((conversation, index) => (
								<ChatListRow
									key={conversation.id}
									conversation={conversation}
									isLast={index === items.length - 1}
									onClick={() => openConversation(conversation)}
								/>
							))}
						</Box>
						<Box height="env(safe-area-inset-bottom, 8px)" />
					</>
				)}
			</Stack>
		</Stack>
	);
};
